import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProcessExecutionServiceV2 } from '@netfoundry-ui/shared/apiv2';

import moment from 'moment';
import { JsonViewComponent } from '@netfoundry-ui/ui/json-view';

@Component({
    selector: 'app-precheck-details',
    templateUrl: './precheck-details.component.html',
    styleUrls: ['./precheck-details.component.scss'],
    standalone: false
})
export class PrecheckDetailsComponent implements OnInit {
    @ViewChild(JsonViewComponent, { static: false }) editor!: JsonViewComponent;
    process: any = {};
    processDetails: any = {};
    // precheckData : any = {};
    args: string | null = null;
    // precheckData!: any[];
    precheckData: any[] = [];
    originalStep;

    constructor(
        public dialogRef: MatDialogRef<PrecheckDetailsComponent>,
        private processExecutionService: ProcessExecutionServiceV2,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.originalStep = this.data.step
        this.precheckData = this.data.step.data.details;
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
